import React from 'react';
import './LoadingSkeleton.css';

export const AssessmentDetailsSkeleton = () => {
  return (
    <div className="assessment-loading">
      <div className="assessment-header-skeleton">
        <div className="skeleton back-button-skeleton"></div>
        <div className="title-skeleton">
          <div className="skeleton skeleton-title"></div>
          <div className="skeleton skeleton-subtitle"></div>
        </div>
        <div className="actions-skeleton">
          <div className="skeleton action-button-skeleton"></div>
          <div className="skeleton action-button-skeleton"></div>
          <div className="skeleton action-button-skeleton"></div>
        </div>
      </div>
      
      <div className="students-loading">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="student-card-skeleton">
            <div className="student-header-skeleton">
              <div className="skeleton student-avatar-skeleton"></div>
              <div className="skeleton student-name-skeleton"></div>
              <div className="skeleton student-score-skeleton"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const ClassAssessmentsSkeleton = () => {
  return (
    <div className="class-assessments-loading">
      {[...Array(6)].map((_, index) => (
        <div key={index} className="assessment-card-skeleton">
          <div className="card-header-skeleton">
            <div className="skeleton card-date-skeleton"></div>
            <div className="skeleton card-title-skeleton"></div>
          </div>
          <div className="skeleton card-category-skeleton"></div>
          <div className="card-details-skeleton">
            <div className="skeleton card-detail-skeleton"></div>
            <div className="skeleton card-detail-skeleton"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const LoadingSpinner = ({ text = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <div className="loading-text">{text}</div>
    </div>
  );
};

export default { AssessmentDetailsSkeleton, ClassAssessmentsSkeleton, LoadingSpinner };
